interface Route {
  path: string
  createPath: (params: Partial<Record<string, string>>) => string
  isRoute: (path: string) => boolean
}

export const Routes = {
  LoginPage: { path: '/login', createPath: () => '/login', isRoute: (path: string) => /^\/login$/.test(path) },
  IntroPage: { path: '/intro', createPath: () => '/intro', isRoute: (path: string) => /^\/intro$/.test(path) },
  WelcomePage: { path: '/welcome', createPath: () => '/welcome', isRoute: (path: string) => /^\/welcome$/.test(path) },
  RepositoriesPage: {
    path: '/repositories',
    createPath: () => '/repositories',
    isRoute: (path: string) => /^\/repositories$/.test(path),
  },
  HomePage: { path: '/', createPath: () => '/', isRoute: (path: string) => /^\/$/.test(path) },
  AnalysisDetailsPageDeprecated: {
    path: '/analysis/:analysisId/:scanId',
    createPath: ({ analysisId, scanId }) => `/analysis/${analysisId}/${scanId}`,
    isRoute: (path: string) => /^\/analysis\/[^\/]+\/[^\/]+$/.test(path),
  },
  AnalysisDetailsPage: {
    path: '/analysis/:analysisId',
    createPath: ({ analysisId, queryString }) => `/analysis/${analysisId}${queryString ? `?${queryString}` : ''}`,
    isRoute: (path: string) => /^\/analysis\/[^\/]+$/.test(path),
  },
  AnalysisDetailsPageFindingFixDrawerDeprecated: {
    path: '/analysis/:analysisId/fix/:findingId',
    createPath: ({ analysisId, findingId, queryString }) => `/analysis/${analysisId}/fix/${findingId}${queryString ? `?${queryString}` : ''}`,
    isRoute: (path: string) => /^\/analysis\/[^\/]+\/fix\/[^\/]+$/.test(path),
  },
  AnalysisDetailsPageFindingFixDrawer: {
    path: '/analysis/:analysisId/finding/:findingId/fixes',
    createPath: ({ analysisId, findingId, queryString }) =>
      `/analysis/${analysisId}/finding/${findingId}/fixes${queryString ? `?${queryString}` : ''}`,
    isRoute: (path: string) => /^\/analysis\/[^\/]+\/finding\/[^\/]+\/fixes$/.test(path),
  },
  AnalysisDetailsPageFindingTriageDrawer: {
    path: '/analysis/:analysisId/finding/:findingId/triage',
    createPath: ({ analysisId, findingId, queryString }) =>
      `/analysis/${analysisId}/finding/${findingId}/triage${queryString ? `?${queryString}` : ''}`,
    isRoute: (path: string) => /^\/analysis\/[^\/]+\/finding\/[^\/]+\/triage$/.test(path),
  },
  ScansOverviewPage: {
    path: '/scans/',
    createPath: () => '/scans/',
    isRoute: (path: string) => /^\/scans\/$/.test(path),
  },
} satisfies Record<string, Route>

export type RouteKey = keyof typeof Routes
